<table class="key-value-pair-table">
  @for (pair of data(); track pair.key) {
    <tr>
      <td [ngClass]="pair.keyAligning ? 'align-' + pair.keyAligning : null">{{ pair.key }}</td>
      <td>
        @if (Array.isArray(pair.value)) {
          <div class="flex flex-col gap-2">
            @for (subValue of pair.value; track $index) {
              <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: subValue }"/>
            }
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="valueTemplate; context: { $implicit: pair.value }"/>
        }
      </td>
    </tr>
  }
</table>

<ng-template #valueTemplate let-currentValue>
  @if (currentValue == null || currentValue === '') {
    --
  } @else if (currentValue === true) {
    <span class="text-green-600 font-bold">&#10003;</span>
  } @else if (currentValue === false) {
    <span class="text-red-600 font-bold">&#10007;</span>
  } @else if (isValueDate(currentValue)) {
    {{ currentValue | localMoment: 'LL' }}
  } @else if (isValuePageLink(currentValue)) {
    <a class="font-bold text-blue-500 underline" [routerLink]="currentValue.url"
       [queryParams]="currentValue.queryParams">
      {{ currentValue.displayName }}
    </a>
  } @else if (isValueTemplate(currentValue)) {
    <ng-container *ngTemplateOutlet="currentValue.template; context: { $implicit: currentValue.value }"/>
  } @else {
    {{ currentValue }}
  }
</ng-template>
